// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/shared/DiagnosticoHeroCTA.jsx
//  Entrada al Motor de Diagnóstico desde la landing de alumnos.
//
//  docs/onboarding-master-v2.md, Parte III §1:
//    "El CTA hacia /onboarding debe vivir dentro de ella (botón hero o
//     similar), no en el header."
//
//  Se AGREGA junto a los CTAs existentes del hero, sin sustituir ninguno: el
//  botón de prueba gratuita hacia /register es copy de conversión que ya está
//  en producción y no forma parte del alcance de este microservicio.
//  Trae su propio CSS prefijado para no tocar LHero.css.
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import './DiagnosticoHeroCTA.css';

export default function DiagnosticoHeroCTA() {
  return (
    <Link to="/diagnostico" className="ob-hero-cta">
      <span className="ob-hero-cta-icon" aria-hidden="true">🎯</span>
      <span className="ob-hero-cta-body">
        <span className="ob-hero-cta-title">Descubre tu nivel real en 60 segundos</span>
        <span className="ob-hero-cta-sub">Sin examen, sin registro — solo tu punto de partida</span>
      </span>
      <span className="ob-hero-cta-arrow" aria-hidden="true">→</span>
    </Link>
  );
}
